import React, { useState } from 'react';
import { Tooltip, Popover, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Tooltip that works on mobile: on desktop uses hover; on touch devices uses tap to open a popover.
 * Use for help icons and other info that must be accessible without hover.
 */
const TouchFriendlyTooltip = ({ title, children, arrow = false, ...tooltipProps }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => {
    if (isMobile) {
      e.preventDefault();
      e.stopPropagation();
      setAnchorEl(e.currentTarget);
    }
  };

  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  if (isMobile) {
    return (
      <>
        <span
          onClick={handleOpen}
          onTouchEnd={(e) => {
            e.preventDefault();
            handleOpen(e);
          }}
          style={{ display: 'inline-flex', cursor: 'pointer' }}
        >
          {children}
        </span>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
          PaperProps={{
            sx: {
              maxWidth: 320,
              p: 2,
              borderRadius: 2,
              backgroundColor: theme.palette.mode === 'dark' ? '#1a1a1a' : '#ffffff',
              boxShadow: theme.palette.mode === 'dark' ? '0 10px 40px rgba(0,0,0,0.5)' : '0 10px 40px rgba(0,0,0,0.12)',
              border: theme.palette.mode === 'dark' ? '1px solid rgba(255,255,255,0.08)' : '1px solid #e2e8f0',
            },
          }}
        >
          {typeof title === 'object' && title !== null ? title : <>{title}</>}
        </Popover>
      </>
    );
  }

  return (
    <Tooltip title={title} arrow={arrow} {...tooltipProps}>
      {children}
    </Tooltip>
  );
};

export default TouchFriendlyTooltip;
